import Image from "next/image"
import React, { FC, useState, Dispatch, SetStateAction, useEffect } from "react"
import logo from "../../public/images/logo-black.png"
import lightLogo from "../../public/images/logo-white.png"
import { LocalStorage } from "@/lib/types/LocalStorage"
import { Localstorage, formattedDateNewYork } from "@/lib/services"
import { useRouter } from "next/router"
import { Modal } from "./Modal"
import siteLogo from "../../public/images/2 (2).png"
import siteDarkName from "../../public/images/BRONCO-black-logo.png"
import siteLightName from "../../public/images/BRONCO-White-logo.png"


import {
  MagnifyingGlassIcon,
  MoonIcon,
  SunIcon,
  UserIcon,
} from "@heroicons/react/24/outline"
import { useMutation } from "react-query"
import {
  Geo,
  MexicoMarket,
  UserMexicoMarketResponse,
  Quote,
  Role,
  Search,
} from "@/lib/types"
import { api } from "@/lib/api"
import { ThemeToggle } from "./ThemeToggle"
import { Dropdown, SearchUser } from "./Dropdown"
import { useTheme } from "@/lib/context/ThemeContext"

type Props = {
  title: string
  icon: any
  role: Role
  salesRepId: string
  slug: string
  quote?: Quote
  isSuccess?: boolean
  mexico?: boolean
  geoLocations?: {
    origin: Geo["geoLocations"]
    destination: Geo["geoLocations"]
  }
  handleForm?: (form: Quote) => void
  mexicoMarketData?: {
    mexicoMarket: string | undefined
    bound: string | undefined
  }
  setId: Dispatch<SetStateAction<string>>
  setMexico?: Dispatch<SetStateAction<boolean>>
  setSelectedUserId?: Dispatch<SetStateAction<string>>
  setSelectedUser?: Dispatch<SetStateAction<any>>
}

export const Header: FC<Props> = (props) => {
  const { pathname } = useRouter()
  const router = useRouter()
  const { isDarkMode } = useTheme()
  const currentDate = formattedDateNewYork()
  const [userPopup, setUserPopup] = useState(false)
  const [mexicoMarket, setMexicoMarket] = useState(false)
  const [userName, setUserName] = useState<string>("Select Customer")
  const [onSelectUser, setOnSelectUser] = useState<SearchUser>()
  const user = Localstorage.get<LocalStorage>("next.user")
  const [search, setSearch] = useState({
    input: "",
    userRole: props.role,
    salesRepID: props.salesRepId,
  })

  let copyData = { ...props.quote }
  copyData.pickUpDate = currentDate

  const mutation = useMutation((payload: Search) => {
    return api.AdminApi.Search(payload)
  })

  useEffect(() => {
    if (pathname == "/customer-dashboard" || pathname == "/sales-dashboard") {
      mutation.mutate({
        input: "",
        userRole: "CUSTOMER",
        salesRepID: "",
      })
    }
  }, [])

  useEffect(() => {
    if (
      props.mexico &&
      props.mexicoMarketData?.mexicoMarket &&
      props.mexicoMarketData?.bound
    ) {
      setMexicoMarket(true)
    } else if (props.mexico == false) {
      setMexicoMarket(false)
    }
  }, [
    props.mexicoMarketData?.mexicoMarket,
    props.mexicoMarketData?.bound,
    props.mexico,
  ])

  const populateData = (id: string, name: string) => {
    props.setId(id)
    setUserName(name)
  }

  useEffect(() => {
    if (onSelectUser) {
      if(props.setSelectedUser){
        props.setSelectedUser(onSelectUser)
      }
    }
  }, [onSelectUser])

  return (
    <>
      <Modal
        close={() => setUserPopup(false)}
        open={userPopup}
        width="small"
        title="Customers"
      >
        <div className="flex flex-col gap-2">
          <Dropdown
            isCheck={true}
            firstname={false}
            search={search}
            handleSearch={(input) => mutation.mutate(input)}
            listingOfUsers={
              mutation.data == undefined ? null : mutation.data.topMatchingUsers
            }
            selectedUser={onSelectUser}
            setSelectedUser={setOnSelectUser}
            populateData={populateData}
          />
        </div>
      </Modal>
      <div className="relative md:p-4 p-2 md:h-20 h-16 w-full flex items-center dark:bg-secondary-8 bg-[#fafafa] border-b-2 dark:border-secondary-10">
        <div className="flex justify-between items-center w-full">
          <div className="flex items-center gap-8 min-w-[220px]">
            {/* {isDarkMode == true ? ( */}
            <Image
              className="w-fit h-11"
              src={siteLogo.src}
              width={100}
              height={100}
              alt="logo"
            />
            {/* ) : (
              <Image
                className="w-fit h-11"
                src={lightLogo.src}
                width={100}
                height={100}
                alt="logo"
              />
            )} */}
          </div>

          <span className="md:flex hidden md:max-w-[200px] lg:max-w-[300px] xl:max-w-[350px]">
            {isDarkMode == true ? (
              <Image
                className="w-full h-auto"
                src={siteLightName.src}
                width={200}
                height={200}
                alt="logo"
              />
            ) : (
              <Image
                className="w-full h-auto"
                src={siteDarkName.src}
                width={100}
                height={100}
                alt="logo"
              />
            )}
            {/* <h2 className="italic font-semibold text-secondary-2 dark:text-primary-2">BRONCO TRANSPORTATION SERVICES</h2> */}
          </span>
          <div className="flex items-center justify-end gap-2 ">
            <ThemeToggle
            // isDarkMode={isDarkMode}
            // setIsDarkMode={setIsDarkMode}
            />
            {user?.role == "ADMIN" && pathname == "/customer-dashboard" ? (
              <div className="border-r-2 flex flex-col items-center justify-center gap-y-1 pr-px">
                <UserIcon className="w-6 h-6 dark:text-primary-10 text-light-2" />

                <h5
                  className="text-center outline-none dark:text-primary-8 text-light-1 text-sm w-36 cursor-pointer"
                  onClick={() => setUserPopup(true)}
                >
                  {userName}
                </h5>
              </div>
            ) : (
              pathname == "/sales-dashboard" && (
                <div className="border-r-2 flex flex-col items-center justify-center gap-y-1 pr-px">
                  <UserIcon className="w-6 h-6 dark:text-primary-10 text-light-2" />

                  <h5
                    className="bg-transparent text-center outline-none dark:text-primary-8 text-light-1 text-sm w-36 cursor-pointer"
                    onClick={() => setUserPopup(true)}
                  >
                    {userName}
                  </h5>
                </div>
              )
            )}
            <div className="flex items-center gap-x-3">
              <div className="text-end sm:block hidden">
                <h5 className="dark:text-primary-10 text-light-2 text-sm font-semibold pr-2 leading-6">
                  {user?.firstName as string} {user?.lastName as string}
                </h5>
                <p className="text-xs dark:text-primary-10 text-light-2">
                  {user?.email as string}
                </p>
              </div>
              <Image
                className="w-11 h-11 object-cover rounded-full cursor-pointer"
                onClick={() => router.push("/user-profile")}
                src={user?.profilePicture as string}
                width={100}
                height={100}
                alt="Profile Picture"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Header
